module.exports = __webpack_public_path__ + "img/COQUILLAGE.275b8340.png";